import React, {useState} from "react"
import Row from "@amzn/meridian/row"
import Button from "@amzn/meridian/button"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Currency from "../common/currency";
import RadioButton from "@amzn/meridian/radio-button";
import ModalFooter from "@amzn/meridian/modal/modal-footer";
import Column from "@amzn/meridian/column";
import Alert from "@amzn/meridian/alert";
import {getStationCode} from "../../network/NetworkUtil";
import {submitRemittanceRequest} from '../remittance/network/RemittanceAPI';
import AlertModal from "./alertModal";
import commonUtils from "../common/commonUtils";
import RemittanceSection from "./deposit/remittanceSection";
import VarianceSection from "./deposit/varianceSection";
import SectionDetails from "./deposit/sectionDetails";
import Card, {CardHeader} from "@amzn/meridian/card";
import Heading from "@amzn/meridian/heading";
import Tooltip from "@amzn/meridian/tooltip";
import { publishCount } from "../../MetricUtility";
import { Metric, PROCESS_NAME} from "../common/constants";



const OverviewSection = ({onIsExactAmountChange, amountValues}) => {
    console.log({amountValues});
    const [exactAmountSubmitted, setExactAmountSubmitted] = useState("true")

    const {amount = '', variance = '', cashToBeSubmitted = ''} = amountValues;
    const toggleExactAmount = event => {
        setExactAmountSubmitted(event);
        onIsExactAmountChange(event);
    }

    return (<Box>
        <Row>
            <SectionDetails title="Overview" description="Add the deposit code for the cash amount collected manually"/>
        </Row>
        <Column space="small">
            <Row spacingInset="xxsmall" widths={["grid-4", "grid-4","grid-4"]} >
                <Tooltip position="right" title = "This is the amount all drivers should have collected based on the packages delivered" >
                    <Card>
                        <CardHeader>
                            <Heading level={4} type="b100">
                                <b>Expected Cash</b>
                            </Heading>
                        </CardHeader>
                        <Currency amount={amount}/>
                    </Card>
                </Tooltip>
                <Tooltip position="right" title = "This is the amount collected by the station" >
                    <Card>
                        <CardHeader>
                            <Heading level={4} type="b100">
                                <b>Actual Cash</b>
                            </Heading>
                        </CardHeader>
                        <Currency amount={cashToBeSubmitted}/>
                    </Card>
                </Tooltip>
                <Tooltip position="right" title = "This is Expected - Actual">
                    <Card>
                        <CardHeader>
                            <Heading level={4} type="b100">
                               <b> Short/Excess</b>
                            </Heading>
                        </CardHeader>
                        <Currency isVariance={true} amount={variance}/>
                    </Card>
                </Tooltip>
            </Row>

            <Box>
                <Row>
                    <Text type="h100">Are you submitting the exact amount as the Actual cash collected?</Text>
                </Row>
                <Row spacingInset="small none">
                    <RadioButton
                        checked={exactAmountSubmitted === "true"}
                        onChange={toggleExactAmount}
                        name="exactAmountSubmitted"
                        value="true">Yes
                    </RadioButton>
                </Row>
                <Row>
                    <RadioButton
                        checked={exactAmountSubmitted === "false"}
                        onChange={toggleExactAmount}
                        name="exactAmountSubmitted"
                        value="false">
                        No
                    </RadioButton>
                </Row>
            </Box>
        </Column>
    </Box>);
}

const AddDepositModal = (props) => {

    const {addDepositModalData, countryCode} = props;
    const [isExactAmount, setIsExactAmount] = useState("true");
    const [actualCashSubmitted, setActualCashSubmitted] = useState(0);
    const [coins, setCoins] = useState(0);
    const [coinCashType, setCoinCashType] = useState("SHORT");
    const [soiledNotes, setSoiledNotes] = useState(0);
    const [soiledCashType, setSoiledCashType] = useState("SHORT");
    const [othersCash, setOthersCash] = useState(0);
    const [slpRecoveryAmount, setSLPRecoveryAmount] = useState(0);
    const [othersCashType, setOthersCashType] = useState("SHORT");
    const [slpRecoveryType, setSLPRecoveryType] = useState("EXCESS");
    const [ttLink, setTtLink] = useState();
    const [slpTTLink, setSLPTTLink] = useState();
    const [remittanceCode, setRemittanceCode] = useState();
    const [confirmRemittanceCode, setConfirmRemittanceCode] = useState();
    const [alertMessage, setAlertMessage] = useState();
    const [alertModal, setAlertModal] = useState({show: false});

    const onClose = event => {
        setAlertMessage(undefined);
        props.onClose(event);
    }

    const onAlertModelClose = event => {
        setAlertModal({show: false});
        onClose(event);
        window.location.reload();
    }

    function validateBreakup(varianceAmountBreakup) {
        console.log("Validating variance breakup : IsExactAmount " + isExactAmount);
        if (isExactAmount === "true") {
            setActualCashSubmitted(Math.round(addDepositModalData.actualAmount.value));
            return true;
        } else {
            let expectedCash = addDepositModalData.actualAmount.value;
            let varianceAmount = 0;
            console.log(varianceAmountBreakup);
            for (let varianceType in varianceAmountBreakup) {
                console.log("Variance : " + varianceType + " " + JSON.stringify(varianceAmountBreakup[varianceType]));
                varianceAmount += varianceAmountBreakup[varianceType].amount;
            }
            let calculatedExpected = actualCashSubmitted - varianceAmount;
            console.log("Expected Cash: " + expectedCash);
            console.log("Actual Submitted : " + actualCashSubmitted);
            console.log("Variance : " + varianceAmount);
            console.log("CalculatedExpected Cash: " + calculatedExpected);

            if (Math.abs(expectedCash - calculatedExpected ) < 1) { /**Difference under 1 is tolerable*/
                setAlertMessage(undefined);
                return true;
            } else {
                setAlertMessage({type: "warning", message: "Invalid breakup"});
                return false;
            }
        }
    }


    const submitRemittance = event => {
        const currencyUnit = addDepositModalData.expectedAmount.unit;
        let varianceBreakup;
        if (isExactAmount === "true") {
            setActualCashSubmitted(Math.round(addDepositModalData.actualAmount.value));
            varianceBreakup = {};
        } else {
            if(countryCode==="AE" || countryCode==="SA"){
                let diff = actualCashSubmitted - addDepositModalData.actualAmount.value;
                let diffType = diff > 0 ? 'EXCESS' : 'SHORT';
                setOthersCash(diff );
                setOthersCashType(diffType);
                console.log("actual submitted filled",actualCashSubmitted,"liability actual amount",
                    addDepositModalData.actualAmount.value,"diff:",diff)

                varianceBreakup = {
                    coins: {
                        type: 'SHORT',
                        amount: 0
                    },
                    soiledNotes: {
                        type: 'SHORT',
                        amount: 0
                    },
                    other: {
                        type: diffType,
                        amount: diff
                    },
                    slpRecovery: {
                        type: 'SHORT',
                        amount: 0
                    }
                };
                console.log("Variance breakup calculated: ",varianceBreakup)
            } else{
                varianceBreakup = {
                    coins: {
                        type: coinCashType,
                        amount: parseInt((coinCashType === 'SHORT') ? -coins : coins, 10)
                    },
                    soiledNotes: {
                        type: soiledCashType,
                        amount: parseInt((soiledCashType === 'SHORT') ? -soiledNotes : soiledNotes, 10)
                    },
                    other: {
                        type: othersCashType,
                        amount: parseInt((othersCashType === 'SHORT') ? -othersCash : othersCash, 10)
                    },
                    slpRecovery: {
                        type: slpRecoveryType,
                        amount: parseInt((slpRecoveryType === 'SHORT') ? -slpRecoveryAmount : slpRecoveryAmount, 10)
                    }
                };
                console.log("Variance breakup filled: ",varianceBreakup)
            }
        }

        function validateRemittanceCode(remittanceCode, confirmRemittanceCode, currencyUnit) {
            return commonUtils.isValidRemittanceCode(remittanceCode, currencyUnit) && remittanceCode === confirmRemittanceCode
        }

        let isValidBreakup = validateBreakup(varianceBreakup);
        if (!isValidBreakup) {
            setAlertMessage({type: "error", message: "Invalid amount breakup"});
            return false;
        }

        if (!remittanceCode || !commonUtils.isValidRemittanceCode(remittanceCode, currencyUnit)) {
            setAlertMessage({type: "error", message: "Invalid remittance code"});
            return false;
        }

        if (remittanceCode !== confirmRemittanceCode) {
            setAlertMessage({type: "error", message: "Remittance code mismatch"});
            return false;
        }

        function validateInputValues() {
            return isValidBreakup
                && validateRemittanceCode(remittanceCode, confirmRemittanceCode, currencyUnit)
                && commonUtils.isIssueLinkValid(ttLink) && commonUtils.isIssueLinkValid(slpTTLink);
        }

        if (validateInputValues()) {
            return submitRemittanceRequest({
                stationCode: getStationCode(),
                isExactAmount,
                actualCashSubmitted: Math.round(actualCashSubmitted),
                remittanceCode,
                ttLink: (ttLink === "" || ttLink === undefined ? undefined : ttLink.trim()),
                slpRecoveryTTLink: (slpTTLink === "" || slpTTLink === undefined ? undefined : slpTTLink.trim()),
                varianceBreakup,
                remittanceId: addDepositModalData.remittanceId
            }).then(response => {
                if (response.status === 200) {
                    setAlertModal({
                        show: true,
                        title: "Success",
                        message: "Successfully added new deposit",
                        type: "success"
                    });
                    publishCount(PROCESS_NAME, Metric.SubmitRemittance);
                } else {
                    setAlertMessage({type: "error", message: "Failed to Add deposit code."});
                    publishCount(PROCESS_NAME, Metric.SubmitRemittance_Failure);
                    publishCount(PROCESS_NAME, Metric.SubmitRemittance);
                }
            }).catch(error => {
                setAlertMessage({type: "error", message: "Failed to Add deposit code."});
                publishCount(PROCESS_NAME, Metric.SubmitRemittance_Failure);
                publishCount(PROCESS_NAME, Metric.SubmitRemittance);
            });
        } else {
            setAlertMessage({type: "warning", message: "Invalid input values"});
            return false;
        }

    }

    const overviewAmountValues = {
        amount: ((addDepositModalData || {}).expectedAmount || {}),
        variance: ((addDepositModalData || {}).variance || {}),
        cashToBeSubmitted: ((addDepositModalData || {}).actualAmount || {})
    };

    const handleTTChange = event => {
        console.log({event});
        setTtLink(event);
        validateTTLink(event);
    };

    const toggleIsExactAmountSubmitted = event => {
        setIsExactAmount(event);
        if (event === "true") {
            setActualCashSubmitted(Math.round(addDepositModalData.actualAmount.value));
        } else {
            setActualCashSubmitted(0);
        }
        setAlertMessage(undefined);
    };

    function validateTTLink(ttURL) {
        if (commonUtils.isIssueLinkValid(ttURL)) {
            setAlertMessage(undefined);
        } else {
            setAlertMessage({type: "warning", message: "Invalid TT link"});
        }
    }

    return (
        <React.Fragment>
            {
                <React.Fragment>
                    <ModalExample title="Add Deposit Code" open={props.value} scrollContainer="viewport"
                                  width={535} closeLabel="Close" onClose={onAlertModelClose}>
                        {alertMessage && <Alert type={alertMessage.type}>{alertMessage.message}</Alert>}
                        <Box>
                            <form>
                                <Column spacing="medium">
                                    <OverviewSection
                                        onIsExactAmountChange={toggleIsExactAmountSubmitted}
                                        amountValues={overviewAmountValues}
                                    />
                                    <VarianceSection
                                        isExactAmount={isExactAmount}
                                        onActualCashSubmittedChange={setActualCashSubmitted}
                                        onCoinsChange={setCoins}
                                        onCoinCashTypeChange={setCoinCashType}
                                        onSoiledNotesChange={setSoiledNotes}
                                        onSoiledCashTypeChange={setSoiledCashType}
                                        onOthersCashChange={setOthersCash}
                                        onSLPRecoveryChange={setSLPRecoveryAmount}
                                        onOthersCashTypeChange={setOthersCashType}
                                        onTtLinkChange={handleTTChange}
                                        onSLPRecoveryTypeChange={setSLPRecoveryType}
                                        onSLPTTLinkChange={setSLPTTLink}
                                        currencyUnit={overviewAmountValues.amount.unit}
                                    />
                                    <RemittanceSection
                                        onRemittanceCodeChange={setRemittanceCode}
                                        onConfirmRemittanceCodeChange={setConfirmRemittanceCode}
                                        currencyUnit={overviewAmountValues.amount.unit}
                                    />
                                </Column>
                            </form>
                        </Box>
                        <ModalFooter>
                            <Row alignmentHorizontal="right" widths="fit">
                                <Button type="secondary" size="medium" onClick={onClose}>
                                    Cancel
                                </Button>
                                <Button type="primary" size="medium" onClick={submitRemittance}>
                                    Done
                                </Button>
                            </Row>
                        </ModalFooter>
                    </ModalExample>

                    <AlertModal
                        show={alertModal.show}
                        title={alertModal.title}
                        type={alertModal.type}
                        message={alertModal.message}
                        onClose={onAlertModelClose}
                    />
                </React.Fragment>}
        </React.Fragment>
    );
}

export default AddDepositModal;



// WEBPACK FOOTER //
// ./src/component/modal/addDepositModal.js